function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "194.7,204.2 145.3,204.2 129.8,7.8 210.5,7.8 "
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M240.2,53.6l-24.4,35.4c44,17.4,75,59.5,75,108.2c0,64.5-54.4,117-121.1,117s-121.1-52.5-121.1-117 c0-48.7,31-90.8,75-108.2L99.2,53.6C44.1,79.2,5.5,134,5.5,197.5c0,87.9,73.7,159.1,164.5,159.1s164.5-71.2,164.5-159.1 C334.5,134,295.9,79.2,240.2,53.6z"
});

var SvgPowerdmsLogo = function SvgPowerdmsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPowerdmsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/powerdms-logo.2be198af.svg";
export { ForwardRef as ReactComponent };